import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Button,
    ListGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { actions } from '../../../../context';
import moment from 'moment';
import PluginListItem from '../Controls/PluginListItem';

const listHeight = '500px';

const PluginOfferingManagerModal = ({
    offering,
    toggle,
    refresh,
    isOpen = false,
}) => {
    const dispatch = useDispatch();
    const [filter, setFilter] = useState('');
    const [plugins, setPlugins] = useState([]);
    const [loading, setLoading] = useState(false);

    const close = useCallback(() => {
        setFilter('');
        toggle();
    }, [toggle]);

    const refreshPlugins = useCallback(() => {
        setLoading(true);
            return dispatch(actions.missionControl.getActiveNonOfferingPlugins(offering))
            .then((res) => {
                setPlugins(res || []);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching plugins:", error);
                setLoading(false);
            });
    }, [dispatch, offering]);

    const onAddClickSuccessHandler = useCallback(() => {
        close();
        refresh({skipOfferingRefresh: false, skipOfferingListRefresh: true});
    }, [refresh, close]);

    const getFilteredPlugins = () =>
        plugins.filter((x) =>
            x.name.toLowerCase().includes(filter.toLowerCase())
        );

    const filteredPlugins = () => {
        if (filter === '') return plugins;
        if (plugins.length <= 0) return [];
        return getFilteredPlugins();
    };

    useEffect(() => {
        if (isOpen) refreshPlugins();
        // eslint-disable-next-line
    }, [dispatch, isOpen]);

    return (
        <Modal
            className="text-light"
            style={{ minWidth: '45vw' }}
            centered
            isOpen={isOpen}
            toggle={close}>
            <ModalHeader>Add Plugin</ModalHeader>
            <ModalBody>
                {loading ? (
                    <div className="loading-spinner spin-animate mx-auto my-4"></div>
                ) : (
                    <div>
                        <div className="text-center mb-4">
                        <input
                            type="search"
                            placeholder="type to filter on plugin names"
                            className="rounded p-1 w-75 text-center offering-add-plugin-filter-input"
                            onChange={(e) => setFilter(e.target.value)}
                            />
                        </div>
                        <ListGroup
                            style={{
                                minHeight: listHeight,
                                maxHeight: listHeight,
                                overflowY: 'auto',
                            }}>
                            {filteredPlugins().map((p) => (
                                <PluginListItem
                                    key={p.id}
                                    pluginId={p.id}
                                    pluginName={p.name}
                                    defaultVersion={getVersion(p?.defaultPluginVersion)}
                                    offering={offering}
                                    onAddClickSuccess={() => onAddClickSuccessHandler()}
                                />
                            ))}
                        </ListGroup>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={close}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

const getVersion = (version) => {
    const versionFormatted = version?.version ? version.version : '(not available)';
    const releaseDateFormatted = version?.releaseDate ? `\nRelease Date: ${moment(version.releaseDate).format('M/D/YYYY')}` : '';
    const descriptionFormatted = version?.description ? `\nDescription: ${version.description}` : '';
    return `${versionFormatted}${releaseDateFormatted}${descriptionFormatted}`;
}

export default PluginOfferingManagerModal;
